import type { ImportRowLog } from "@/project/karuna/utils/schoolImportRowEngine";
import {
  formatImportLogAction,
  formatImportLogMessage,
} from "@/project/karuna/utils/schoolImportLogFormat";

interface SchoolImportLogTableProps {
  logs: ImportRowLog[];
}

export function SchoolImportLogTable({ logs }: SchoolImportLogTableProps) {
  if (logs.length === 0) {
    return null;
  }

  return (
    <div className="overflow-hidden rounded-lg border">
      <div className="max-h-[420px] overflow-auto">
        <table className="w-full min-w-[640px] border-collapse text-sm">
          <thead className="sticky top-0 z-10 bg-muted/80 backdrop-blur-sm">
            <tr className="border-b text-left">
              <th className="px-4 py-3 font-semibold">Row Number</th>
              <th className="px-4 py-3 font-semibold">Action</th>
              <th className="px-4 py-3 font-semibold">Status</th>
              <th className="px-4 py-3 font-semibold">Message</th>
            </tr>
          </thead>
          <tbody>
            {logs.map(log => {
              const failed = log.status === "FAILED";
              return (
                <tr
                  key={log.row_number}
                  className="border-b align-top last:border-b-0"
                >
                  <td className="px-4 py-4 tabular-nums text-muted-foreground">
                    {log.row_number}
                  </td>
                  <td className="px-4 py-4">
                    <span className="font-medium text-foreground">
                      {formatImportLogAction(log)}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <div className="flex items-center gap-2 whitespace-nowrap">
                      <span
                        className={`inline-block h-2.5 w-2.5 rounded-full ${
                          failed ? "bg-red-500" : "bg-emerald-500"
                        }`}
                        aria-hidden
                      />
                      <span
                        className={`font-medium ${
                          failed ? "text-red-700" : "text-emerald-700"
                        }`}
                      >
                        {failed ? "Failed" : "Success"}
                      </span>
                    </div>
                  </td>
                  <td className="whitespace-pre-line px-4 py-4 text-foreground">
                    {formatImportLogMessage(log)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
